import { IAlignmentLinkState, AlignmentLink } from "./alignment-link";
import { IBasicLinkState, BasicLink } from "./basic-link";

export type { IAlignmentLinkState, IBasicLinkState };
export { AlignmentLink, BasicLink as BaseLink };

export const links = [AlignmentLink, BasicLink];

export type IWhiteboardLinkState = IAlignmentLinkState | IBasicLinkState;
export type WhiteboardLinkStateType = IWhiteboardLinkState["type"];

export * from "./link";

export const linkId = (link: IWhiteboardLinkState): string => `${link.type}_${link.source.type}_${link.source.id}_${link.target.type}_${link.target.id}`;
